import React from "react";
import CompanyPage from "./CompanyPage";
import ContactsPage from "./ContactsPage";
import NewsSection from "../pages_components/main/NewsSection";
import { useSelector } from "react-redux";
import { RootState } from "../_store";
import { IProduct } from "../models/product/IProduct";
import ProductsSection from "../pages_components/ProductsSection";
import { Container } from "react-bootstrap";

export default function MainPage() {

    const allProductions = useSelector((state: RootState) => state.product.products);
    
    const getFavoriteProductions = () => {

        return allProductions.filter((x: IProduct) => x.showInMainPage);
    };

    return (
        <div>
            <NewsSection />
            <Container className="page-container">
                <h2 className="page-container-header">Наши избранные продукты</h2>
                <ProductsSection products={getFavoriteProductions()}/>
            </Container>
            <CompanyPage />
            <ContactsPage />
        </div>
    );
}